<template>
  <el-menu
    class="el-menu-vertical fix-width"
    background-color="#555"
    :router="true"
    @open="handleOpen"
    @close="handleClose"
    text-color="#dfdfdf"
    active-text-color="#FFFFFF"
    :default-active="currentActiveIndex"
    :unique-opened="true"
  >
    <el-submenu index="1" class="nav-submenu">
      <template slot="title">
        <i class="el-icon-s-promotion"></i>
        <span>Express</span>
      </template>
      <el-menu-item index="/quotings">
        <i class="el-icon-edit"></i>Quoting
      </el-menu-item>
      <el-menu-item index="/ocops">
        <i class="el-icon-discount"></i>OCOP Prices
      </el-menu-item>
    </el-submenu>
    <!-- ------------------------sale-------------------------- -->
    <el-submenu index="2">
      <template slot="title">
        <i class="el-icon-s-marketing"></i>
        <span>Sales</span>
      </template>
      <el-menu-item index="/invoices" @click="_handleReloadListReuse('/invoices')">
        <i class="el-icon-document-checked"></i>Invoices
      </el-menu-item>
      <el-menu-item index="/credit_notes" @click="_handleReloadListReuse('/credit_notes')">
        <i class="el-icon-document-delete"></i>Credit Notes
      </el-menu-item>
    </el-submenu>
    <!-- ------------------------purcahse-------------------------- -->
    <el-submenu index="3">
      <template slot="title">
        <i class="el-icon-s-goods"></i>
        <span>Purchase</span>
      </template>
      <el-menu-item index="/purchase_orders" @click="_handleReloadListReuse('/purchase_orders')">
        <i class="el-icon-document-copy"></i>Orders
      </el-menu-item>
      <el-menu-item index="/bills" @click="_handleReloadListReuse('/bills')">
        <i class="el-icon-document-checked"></i>Bills
      </el-menu-item>
      <el-menu-item
        index="/bill_credit_notes"
        @click="_handleReloadListReuse('/bill_credit_notes')"
      >
        <i class="el-icon-document-delete"></i>Credit Notes
      </el-menu-item>
    </el-submenu>
    <!-- ------------------------warehouse-------------------------- -->
    <el-submenu index="4">
      <template slot="title">
        <i class="el-icon-s-home"></i>
        <span>Warehouse</span>
      </template>
      <el-menu-item index="/transfers">
        <i class="el-icon-truck"></i>Transfers
      </el-menu-item>
      <el-menu-item index="/adjustments">
        <i class="el-icon-set-up"></i>Adjustments
      </el-menu-item>
    </el-submenu>
    <!-- ------------------------reports-------------------------- -->
    <el-submenu index="5">
      <template slot="title">
        <i class="el-icon-s-data"></i>
        <span>Reports</span>
      </template>
      <el-menu-item index="/sales_reports">
        <i class="el-icon-pie-chart"></i>Sales Reports
      </el-menu-item>
      <el-menu-item index="/purchase_reports">
        <i class="el-icon-data-line"></i>PUR Reports
      </el-menu-item>
      <el-menu-item index="/inventory_reports">
        <i class="el-icon-data-analysis"></i>Inventory
      </el-menu-item>
      <el-menu-item index="/reports_download">
        <i class="el-icon-download"></i>Downloads
      </el-menu-item>
    </el-submenu>
    <!-- ------------------------base infos-------------------------- -->
    <el-submenu index="6">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span>Base Infos</span>
      </template>
      <el-menu-item index="/products">
        <i class="el-icon-files"></i>Products
      </el-menu-item>
      <el-menu-item index="/customers">
        <i class="el-icon-user"></i>Customers
      </el-menu-item>
      <el-menu-item index="/suppliers">
        <i class="el-icon-bank-card"></i>Suppliers
      </el-menu-item>
      <el-menu-item index="/warehouses">
        <i class="el-icon-house"></i>Warehouses
      </el-menu-item>
      <el-menu-item index="/brands">
        <i class="el-icon-paperclip"></i>Brands
      </el-menu-item>
      <el-menu-item index="/employees">
        <i class="el-icon-collection-tag"></i>Employees
      </el-menu-item>
      <!-- <el-menu-item index="/test">
        <i class="el-icon-collection-tag"></i>test
      </el-menu-item>-->
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  inject: ['reload'],
  name: 'AppNav',
  data () {
    return {
      currentRouteFlag: ''
    }
  },
  computed: {
    currentActiveIndex () {
      const matched = this.$route.matched || []
      if (matched.length >= 1) {
        return matched[matched.length - 1].path
      }
      return ''
    }
  },
  created () {
    this.currentRouteFlag = this.$route.path
  },
  methods: {
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    _handleReloadListReuse (param) {
      // if (param === this.currentRouteFlag) return
      // this.reload()
    }
  }
}
</script>

<style scoped>
.el-menu-vertical {
  text-align: left;
}
.is-active {
  background-color: #be2121 !important;
}
.fix-width {
  width: 200px !important;
  overflow: hidden;
}
</style>
